import React from 'react'
import { Flex } from '../../../../common/styles/global_styles'
import { RadioMain } from './styles'

interface RadioProps {
    value: boolean
    title: string
    editMode: boolean
    required: boolean
    tooltip?: string
    onChange: (input: boolean) => void
}
const Radio = ({ onChange, title, value, editMode }: RadioProps): JSX.Element => {
    return (
        <RadioMain>
            <label className={'radioButtonTitle'}>{title}</label>
            <Flex direction={'row'}>
                <label className={'radioButton'}>
                    <input type="radio" checked={value} onClick={() => onChange(true)} />
                    <span className={'radioButtonCheckmark'}></span>
                </label>
                <label className={'activeLabel'}>Active</label>
                <label className={'radioButton'}>
                    <input type="radio" checked={!value} onClick={() => onChange(false)} />
                    <span className={'radioButtonCheckmark'}></span>
                </label>
                <label className={'inactiveLabel'}>Inactive</label>
            </Flex>
        </RadioMain>
    )
}

export default Radio
